(function () {
    'use strict';

    angular
        .module('BCMControllers')
        .controller('BIABUOwnerEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'biaBuOwnerContainer', 'biaProfileContainer', 'bcmLookups', 'biaBuOwnerService'];

    function Controller($scope, $state, biaBuOwnerContainer, biaProfileContainer, bcmLookups, biaBuOwnerService) {

        $scope.biaBuOwner = biaBuOwnerContainer.BIABUOwner;
        $scope.buOwnerBiaResponsibilities = biaBuOwnerContainer.BIAResponsibilities;
        $scope.biaProfile = biaProfileContainer.BIAProfile;
        $scope.bcmLookups = bcmLookups;

        // Go to BIA Profile
        $scope.goToBIAProfile = function () {
            $state.go('biaProfile.edit');
        };

        $scope.onBiaBuOwnerUpdate = function (biaProfile, bIABUOwners) {
            return biaBuOwnerService.updateBusinessUnitByBusinessUnitHeadID(biaProfile.BIAProfileID, biaProfile.BIABUOwnerID, bIABUOwners[0].BusinessUnit.HeadID).then(function() {
	            $state.go('^', {}, { reload: true });
            });
        };
    }
})();